import { Component, inject, Input } from '@angular/core';
import { ListItemComponent, ListViewComponent } from 'components/layout/list-view/list-view.component';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { FarPayCustomerModel, FarPayResponseModel } from 'models/generated/GormGateway.Models.FarPayResponse';
import { BillingInfoDtoModel } from 'models/generated/Models.BillingInfoDto';
import { Layout } from 'modules/layout';
import { CompanyDataProvider, CompanyDataProviderFactory } from 'services/company-data-provider';
import { DataTracking } from 'services/data-tracking';
import { NavigationService } from 'services/navigation.service';
import { CompanyDashboardComponent } from './company-dashboard.component';
import { CompanyAccountingSettingModel } from 'models/generated/Entities.Accounting.CompanyAccountingSetting';
import { Pipes } from 'modules/pipes';

@Component({
	selector: 'company-information',
	templateUrl: './company-information.component.html',
	providers: [CompanyDataProviderFactory, DataTracking],
	imports: [Layout, ListViewComponent, ListItemComponent, Pipes]
})
export class CompanyInformationComponent {

	@Input('billingInfo')
	set billingInfoOverride(billingInfo: BillingInfoDtoModel | undefined) {
		this._billingInfoOverride = billingInfo;
		if (billingInfo) this.getFarPayInfo();
	}

	@Input() loading = false;
	@Input()
	set company(company: CompanyModel | undefined) {
		if (!company) return;
		this._company = company;
		if (company.id && company.id != '00000000-0000-0000-0000-000000000000') {
			this.dataProvider = this.dataProviderFactory.getProviderForCompanyId(company.id);
			this.dataProvider.getCompanyAccountingSettings().then(s => { this.customerNumbers = s.filter(s => s.customerNo); });
			if (this.billingInfoOverride) this.getFarPayInfo();
		}
	}

	async getFarPayInfo() {
		if (!this.dataProvider) return;
		this.farPayInfo = await this.dataProvider.getFarPayInfo();
	}

	public farPayError() {
		return !!this.farPayInfo?.error || !!this.farPayInfo?.customers.find(customer => customer.agreement?.status?.toLowerCase() == 'error');
	}

	public farPayPending(customer: FarPayCustomerModel) {
		return customer.agreement?.status?.toLowerCase() == 'pending';
	}

	public navigateToCompany() {
		const companyId = this.company?.id;
		if (!companyId) return;

		this.navigation.refreshView(CompanyDashboardComponent).then(viewCompany => {
			viewCompany.companyId = companyId;
		});
	}

	public get billingInfoOverride() { return this._billingInfoOverride; }
	public get company() { return this._company; }
	public customerNumbers?: CompanyAccountingSettingModel[];
	public farPayInfo?: FarPayResponseModel;
	
	private dataProvider?: CompanyDataProvider;
	private _company: CompanyModel = new CompanyModel;
	private _billingInfoOverride?: BillingInfoDtoModel;

	private readonly dataProviderFactory = inject(CompanyDataProviderFactory);
	private readonly navigation = inject(NavigationService);
}
